import { createDataSource } from '@/api';

export const config = {
  name: 'create-database',
  create: createDataSource,
};
